import React, { useEffect, useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import OnboardingConfigurationModalContent from "./ModalContent/OnboardingConfigurationModalContent";
import { useLocation } from "react-router-dom";
import { useGetTerritoryList } from "../FSM/Territories/UseTerriitory";
import {
  useOnboardingStatusData,
  useUpdateOnboardWindow,
} from "./hooks/useOnBoard";
import { showToast } from "../../utils/toastUtils";
import { COLORS } from "../../constants/colors";
import { useExcelPolling } from "../../hooks/useExcelPolling";
import axiosInstance from "../../Api/axiosInstance";
import { API_ENDPOINTS } from "../../Api/apiEndPoints";

const TerritoriesColumns = (
  handleTerritoryChechBox: (row: any) => void,
  selectedTerritoryIds: any,
  pageNo: any = 1
) => [
  {
    name: (
      <div>
        <input
          type="checkbox"
          checked={selectedTerritoryIds?.[`${pageNo}`]?.isSelectedAll || false}
          onClick={() => {
            handleTerritoryChechBox("SelectedAll");
          }}
        />
      </div>
    ),
    cell: (row: any, index: number, column: any, id: any) => (
      <input
        type="checkbox"
        checked={
          selectedTerritoryIds?.[`${pageNo}`]?.data?.includes(row?.id) || false
        }
        onClick={() => {
          handleTerritoryChechBox(row);
        }}
      />
    ),
    width: "50px",
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,
  },
  {
    name: "Territory Name",
    selector: (row: { Name: string }) => row.Name || "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "Territory Code",
    selector: (row: { TerritoryCode: string | any }) =>
      row?.TerritoryCode ?? "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Position",
    selector: (row: { PositionName: string }) => row.PositionName || "-",
    sortable: true,
    width: "150px",
    wrap: true,
  },
  {
    name: "Onboarding Status",
    selector: (row: { Onboarding_status: string }) =>
      row.Onboarding_status || "-",
    sortable: true,
    width: "250px",
    wrap: true,
  },
  {
    name: "Start Date",
    selector: (row: { Start_date: string }) => row.Start_date || "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
  {
    name: "End Date",
    selector: (row: { End_date: string }) => row.End_date || "-",
    sortable: true,
    width: "180px",
    wrap: true,
  },
];

const OnboardingConfiguration = () => {
  const location = useLocation();
  const { orgunitRowData } = location?.state || {};
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [selectedTerritoryIds, setSelectedTerritoryIds] = useState<any>({});
  const [chechStatusSubmitAndUpdate, setchechStatusSubmitAndUpdate] =
    useState<string>("");
  const [territoryDataTable, setTerritoryDataTable] = useState<any>([]);
  const [onboardingStatusData, setOnboardingStatusData] = useState<any>([]);
              const [isDownloading,setIsDownloading]=useState(false)
  const [filterData, setFilterData] = useState({
    serach: "",
    OrgUnit: null,
    page: 1,
    limit: 10,
  });
  const [formData, setFormData] = useState({
    onboarding_status: "",
    start_date: "",
    end_date: "",
  });
  // const [buttonDisable, setButtonDisable] = useState(false);
  const { data: onboardStatusData } = useOnboardingStatusData({ enable: true });

  const { data, isLoading, isSuccess } = useGetTerritoryList({
    enable: orgunitRowData?.OrgunitId ? true : false,
    params: {
      OrgUnit: orgunitRowData?.OrgunitId,
      search: filterData.serach,
      page: filterData.page,
      limit: filterData.limit,
    },
  });
  const { mutate: updateMutate } = useUpdateOnboardWindow();

  const FormattedDataOfOnboardingStatus = (onboardStatusData: any) => {
    try {
      let onboardingStatus: any;
      onboardingStatus = Object.keys(
        onboardStatusData?.data?.OnBoardingStatus
      )?.reduce((arr: any, item) => {
        arr.push({
          id: item,
          label: onboardStatusData?.data?.OnBoardingStatus[item],
        });
        return arr;
      }, []);
      console.log("onboardingStatus", onboardingStatus);
      if (onboardingStatus && onboardingStatus?.length) {
        setOnboardingStatusData(onboardingStatus);
      }
    } catch (error) {
      console.log("error in FormattedDataOfOnboardingStatus");
    }
  };

  useEffect(() => {
    if (onboardStatusData) {
      FormattedDataOfOnboardingStatus(onboardStatusData);
    }
  }, [onboardStatusData]);

  useEffect(() => {
    if (!isLoading && isSuccess && Array.isArray(data?.data?.data)) {
      const formatted = data?.data?.data?.map((item: any) => ({
        id: item?.TerritoryId ?? "-",
        Organisation_unit: item?.UnitName ?? "-",
        Name: item?.TerritoryName ?? "-",
        Onboarding_status: item?.OnBoardingStatus?.value ?? "-",
        Start_date: item?.StartDate ?? "-",
        End_date: item?.EndDate ?? "-",
        Orgunitid: item?.Orgunitid ?? "-",
        PositionId: item?.PositionId ?? "-",
        PositionName: item?.PositionName ?? "-",
      }));
      setTerritoryDataTable(formatted || []);
    }
  }, [isLoading, isSuccess, data]);

  const handleAddModal = (status: string) => {
    setchechStatusSubmitAndUpdate(status);
    setIsModalOpen(!isModalOpen);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setButtonDisable(false);
  };
  const getAllSelectedIds = (selectedTerritoryIds: any) => {
    return Object.values(selectedTerritoryIds)
      .filter((page: any) => Array.isArray(page.data) && page.data.length > 0)
      .flatMap((page: any) => page.data);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setSelectedTerritoryIds({});
    setFormData((prevState: any) => ({
      ...prevState,
      onboarding_status: "",
      start_date: "",
      end_date: "",
    }));
    setButtonDisable(false);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setButtonDisable(true);
    let allSelectedIds = getAllSelectedIds(selectedTerritoryIds);
    // alert(JSON.stringify(formData));
    if (allSelectedIds?.length <= 0) {
      setButtonDisable(false);
      showToast.warning("Please select at least one territory.");
      return;
    }
    if (!formData?.onboarding_status) {
      setButtonDisable(false);
      showToast.warning("Please select a Onboarding Status.");
      return;
    }
    if (!formData?.start_date) {
      setButtonDisable(false);
      showToast.warning("Please select a Start date.");
      return;
    }
    if (!formData?.end_date) {
      setButtonDisable(false);
      showToast.warning("Please select a End date.");
      return;
    }
    if (formData?.start_date > formData?.end_date) {
      setButtonDisable(false);
      showToast.warning("End date should not be earlier than the Start date.");
      return;
    }
    // return
    let body: any = {
      territory_ids: allSelectedIds,
      onboarding_status: formData?.onboarding_status,
      start_date: formData?.start_date,
      end_date: formData?.end_date,
    };
    // alert(JSON.stringify(body))
    // return
    updateMutate(
      { body },
      {
        onSuccess: () => {
          handleClose();
        },
        onError: () => {
          setButtonDisable(false);
        },
      }
    );
  };

  const handlePagination = (pageNo: number) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: pageNo,
    }));
  };
  const handleonChangeRowsPerPage = (limit: any, page: any) => {
    setFilterData((prev: any) => ({
      ...prev,
      page: page,
      limit: limit,
    }));
  };

  const handleTerritoryChechBox = (row: any) => {
    try {
      const page = filterData?.page;
      setSelectedTerritoryIds((prev: any) => {
        const pageData = prev[page] || { isSelectedAll: false, data: [] };

        if (row === "SelectedAll") {
          const isNowSelectedAll = !pageData.isSelectedAll;
          return {
            ...prev,
            [page]: {
              isSelectedAll: isNowSelectedAll,
              data: isNowSelectedAll
                ? territoryDataTable.map((item: any) => item.id)
                : [],
            },
          };
        } else {
          const isSelected = pageData.data.includes(row.id);
          const updatedData = isSelected
            ? pageData.data.filter((id: number) => id !== row.id)
            : [...pageData.data, row.id];

          return {
            ...prev,
            [page]: {
              isSelectedAll: updatedData.length === territoryDataTable.length,
              data: updatedData,
            },
          };
        }
      });
    } catch (error) {
      console.log("error in handleTerritoryChechBox", error);
    }
  };

  // console.log('seletedTerrridsss', JSON.stringify(selectedTerritoryIds) + "-------" + filterData?.page);
  // console.log("onboardingStatusData", onboardingStatusData);

    const handleExcel = async () => {
  try {
    setIsDownloading(true);

    const appToken = localStorage.getItem("Apptoken") || "";
    const OrgUnit = orgunitRowData?.OrgunitId || "";
   
    const search = filterData?.serach || "";

    const params = new URLSearchParams();

    // Append only if the value exists
    if (OrgUnit) params.append("OrgUnit", OrgUnit);
    if (search) params.append("search", search);

    const response = await fetch(
      `https://tspc-development.truesales.in/admin/api/getAllTerritoriesListExcel?${params.toString()}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",
          apptoken: appToken,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download Excel file");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "All Territories List Excel.xlsx"; // custom filename
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading Excel file:", error);
  }  finally{
     setIsDownloading(false);
  }
};


  return (
    <div className="p-2">
      <PageHeader
        title="Onboarding Configuration"
        buttons={[
          {
            label: "+ Create Onboard window",
            color:
              getAllSelectedIds(selectedTerritoryIds).length === 0
                ? "grey"
                : "#43B9B2",
            onClick: () => handleAddModal("Submit"),
            disable: getAllSelectedIds(selectedTerritoryIds).length === 0,
          },
                    {
            label: isDownloading ? "Downloading..." : "Excel",
            onClick:handleExcel,
            color: "#43B9B2",
            disable:isDownloading

          },
        ]}
      />
      <BasicDataTable
        Title="Territories List"
        columns={TerritoriesColumns(
          handleTerritoryChechBox,
          selectedTerritoryIds,
          filterData?.page
        )}
        data={territoryDataTable || []}
        headerContent={<></>}
        showSpinner={isLoading}
        paginationRowPerPageOptions={[10, 50, 100, 500, 1000]}
        search={true}
        handleSearch={(text: any) =>
          setFilterData((prev: any) => ({
            ...prev,
            serach: text,
          }))
        }
        onChangePage={(pageNo: number) => handlePagination(pageNo)}
        onChangeRowsPerPage={(newPerPage: any, page: any) =>
          handleonChangeRowsPerPage(newPerPage, page)
        }
        paginationTotalRows={
          !isLoading && isSuccess && data?.data?.pagination?.total_records
        }
      />

      <RouteModal
        isOpen={isModalOpen}
        title={
          chechStatusSubmitAndUpdate === "Submit"
            ? "Add Onboarding Window"
            : "Edit Onboarding Window"
        }
        size="md"
        toggle={toggleModal}
        content={
          <OnboardingConfigurationModalContent
            setFormData={setFormData}
            formData={formData}
            onboardingStatus={onboardingStatusData}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            chechStatusSubmitAndUpdate={chechStatusSubmitAndUpdate}
            buttonDisable={buttonDisable}
          />
        }
      />
    </div>
  );
};

export default OnboardingConfiguration;
